
import ClipboardIcon from "@assets/icon/clipboard.svg?react";
import { SolidButton, SolidButtonProps } from "@components/form/button/SolidButton";
import { cn } from "@utils/tailwind-merge";
import { toast } from "react-toastify";








export interface CopyButtonProps extends SolidButtonProps {
  content?: string
}




export function CopyButton({content, className, ...props}: CopyButtonProps) {

  function copy() {
    if(content){
      navigator.clipboard.writeText(content);
      toast.success("text disalin")
    }
    
  }

  return (
    <SolidButton onClick={copy} className={cn("inline-flex gap-2", className)} {...props}>
      <ClipboardIcon className="w-5 h-5 text-white" />
      Salin
    </SolidButton>
  )
}